/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbSpecificiteCoursDto
 */
export interface FcbSpecificiteCoursDto {
    /**
     * 
     * @type {string}
     * @memberof FcbSpecificiteCoursDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbSpecificiteCoursDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSpecificiteCoursDto
     */
    creationUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbSpecificiteCoursDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbSpecificiteCoursDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbSpecificiteCoursDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSpecificiteCoursDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSpecificiteCoursDto
     */
    isCompanySearch?: boolean;
}

/**
 * Check if a given object implements the FcbSpecificiteCoursDto interface.
 */
export function instanceOfFcbSpecificiteCoursDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSpecificiteCoursDtoFromJSON(json: any): FcbSpecificiteCoursDto {
    return FcbSpecificiteCoursDtoFromJSONTyped(json, false);
}

export function FcbSpecificiteCoursDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSpecificiteCoursDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'isCompanySearch': !exists(json, 'isCompanySearch') ? undefined : json['isCompanySearch'],
    };
}

export function FcbSpecificiteCoursDtoToJSON(value?: FcbSpecificiteCoursDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'libelle': value.libelle,
        'creationUser': value.creationUser,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'actif': value.actif,
        'isCompanySearch': value.isCompanySearch,
    };
}

